import { render, staticRenderFns } from "./LoginTipContent.vue?vue&type=template&id=38236bf2&scoped=true&"
import script from "./LoginTipContent.vue?vue&type=script&lang=js&"
export * from "./LoginTipContent.vue?vue&type=script&lang=js&"
import style0 from "./LoginTipContent.vue?vue&type=style&index=0&id=38236bf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38236bf2",
  null
  
)

export default component.exports